export default "__VITE_ASSET__BJBFqgAI__"